module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container is-child"
  }, [_c('article', {
    staticClass: "segment"
  }, [_c('h1', {
    staticClass: "has-text-centered"
  }, [_vm._v("Shot Quality")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-category has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_name)), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.goals))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.xg))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.shot_on_target))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.shot_attempts))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.home_shots.shooting_percentage))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-category has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_name) + " "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.goals))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.xg))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.shot_on_target))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.shot_attempts))]), _vm._v(" "), _c('p', {
    staticClass: "stat-number has-text-centered"
  }, [_vm._v(_vm._s(_vm.away_shots.shooting_percentage))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("Team "), _c('br')]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("XG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("SOT")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("Shot Attempts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title has-text-centered"
  }, [_vm._v("SH%")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-944c4aea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/shots-quality.vue
// module id = 648
// module chunks = 30